import React, { FC, useCallback, useMemo, memo } from 'react'
import { Icon } from '@wmgtech/legato'
import { useFormContext } from 'react-hook-form'
import { FormSlider } from './FormSlider'
import { IProductForm } from '../ProductTable'
import { useProductUpdate } from '../../serviceHooks'

import { MenuProps } from './menu.props'

const Menu: FC<MenuProps> = ({ onDelete, onAlterNames, idx, disabledEdit }) => {
  const { getValues, setValue } = useFormContext<IProductForm>()
  const { updateProduct } = useProductUpdate(false)

  const prefix = useMemo<`products.${number}`>(() => `products.${idx}`, [idx])

  const handleChange = useCallback(() => {
    updateProduct(getValues(prefix))
  }, [getValues, prefix, updateProduct])

  return (
    <>
      <button
        type="button"
        disabled={disabledEdit}
        onClick={() => setValue('editRow', idx)}
        className="table-row-actions__item table-row-actions__item--btn"
      >
        Edit Product <Icon name="pencil" />
      </button>
      <FormSlider fieldName={`${prefix}.radio_updates`} onChange={handleChange}>
        Automated Radio Stories
      </FormSlider>
      <FormSlider fieldName={`${prefix}.dsp_updates`} onChange={handleChange}>
        Automated DSP Stories
      </FormSlider>
      <button
        type="button"
        onClick={() => onAlterNames(idx)}
        className="table-row-actions__item table-row-actions__item--btn"
      >
        Alternative Names <Icon name="signature" />
      </button>
      <button
        type="button"
        disabled={disabledEdit}
        onClick={() => onDelete(idx)}
        className="table-row-actions__item table-row-actions__item--btn"
      >
        Delete Product <Icon name="trash-can" />
      </button>
    </>
  )
}

export default memo(Menu)
